import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const Script = ({ src, strategy, ...props }) => <script src={src} {...props} />;
const Review = () => {
    return (_jsxs("section", { className: "w-full bg-white py-16 sm:py-20 lg:py-28", children: [_jsx("div", { className: "container mx-auto px-4 sm:px-6 lg:px-8", children: _jsx("div", { className: "elfsight-app-8e20ea5f-3e59-43c4-ad63-c907becf4a0e", "data-elfsight-app-lazy": "" }) }), _jsx(Script, { src: "https://elfsightcdn.com/platform.js", strategy: "afterInteractive" })] }));
};
export default Review;
